import { FormattedMessage } from 'react-intl';

export const WorkingTime = () => (
  <p>
    <FormattedMessage defaultMessage="Прием заявок круглосуточно и без выходных." />
    <br />
    <FormattedMessage defaultMessage="Рассмотрение и отправка денег" />
    :
    <br />
    <FormattedMessage defaultMessage="Пн-Пт" />
    <span> | 09:00-18:00</span>
  </p>
);
